module.exports = __webpack_public_path__ + "static/images/logo3.0035d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head/logo3.png
// module id = sV85
// module chunks = 1